<template>
  <div>
    <el-dialog
      :visible.sync="addVisible"
      :close-on-click-modal="false"
      :before-close="clearAdd"
      width="1000px"
    >
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="Order information" name="first" style="overflow: auto;height: 500px;">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span class="lebh">ASN information</span>
              <span
                style="float: right; padding: 3px 0;color:#f36a21"
                v-if="companyList.asnInf.status==2"
              >Unreceived</span>
              <span
                style="float: right; padding: 3px 0;color:#f36a21"
                v-if="companyList.asnInf.status==4||companyList.asnInf.status==3||companyList.asnInf.status==5"
              >Processing</span>
              <span
                style="float: right; padding: 3px 0;color:#f36a21"
                v-if="companyList.asnInf.status==6"
              >Completed</span>
              <span
                style="float: right; padding: 3px 0;color:#f36a21"
                v-if="companyList.asnInf.status==7"
              >harvest</span>
              <span
                style="float: right; padding: 3px 0;color:#f36a21"
                v-if="companyList.asnInf.status==0"
              >Deleted</span>
            </div>
            <el-col :span="24">
              <div class="purple">
                <el-col :span="6">ASN order number :</el-col>
                <el-col :span="18">{{companyList.asnInf.asnCode}}</el-col>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="purple">
                <el-col :span="6">Reference No :</el-col>
                <el-col :span="18">{{companyList.asnInf.referenceNo}}</el-col>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="purple">
                <el-col :span="6">Warehouse :</el-col>
                <el-col :span="18">{{companyList.asnInf.warehouseName}}</el-col>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="purple">
                <el-col :span="6">Creation time :</el-col>
                <el-col :span="18">{{companyList.asnInf.created}}</el-col>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="purple">
                <el-col :span="6">Insurance :</el-col>
                <el-col :span="18">
                  <span v-if="companyList.asnInf.insuranceFee==0">routine</span>
                  <span v-else>urgent</span>
                </el-col>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="purple" style="height:60px">
                <el-col :span="6">Arrival destination :</el-col>
                <el-col :span="18" class="color">{{companyList.asnInf.warehouseAddressEn}}</el-col>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="purple" style="height:60px">
                <el-col :span="6">Shipping information :</el-col>
                <el-col :span="18">
                  <span v-if="companyList.asnInf.receivingWay==1">Self mention</span>
                  <span
                    v-else
                  >{{companyList.trackingInformation.trackingNumber}}{{companyList.trackingInformation.carrier}} </br>{{companyList.trackingInformation.contactPerson}} {{companyList.trackingInformation.contactNumber}}</span>
                </el-col>
              </div>
            </el-col>
          </el-card>
          <div style="margin-top: 10px;">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span class="lebh">SKU information</span>
              </div>
              <div style="text-align: center">
                <el-table :data="companyList.asnItem" stripe style="width: 100%">
                  <el-table-column prop="sku" label="sku" align="center"></el-table-column>
                  <el-table-column prop="title" label="name" align="center"></el-table-column>
                  <el-table-column prop="quantity" label="quantity" align="center"></el-table-column>
                  <el-table-column prop="weight" label="weight" align="center"></el-table-column>
                     <el-table-column   prop="orderQty" label="Reservation/actual arrival" align="center">
                         <template slot-scope="scope" >
                      {{scope.row.orderQty}}/{{scope.row.receivedQty }}
                    </template>
                   </el-table-column>
                   <el-table-column prop="putawayQuantity" label="Qualified/unqualifiedquantity" align="center">
                         <template slot-scope="scope" >
                      {{scope.row.putawayQuantity}}/{{scope.row.problemQuantity}}
                    </template>
                   </el-table-column>
                 
                  <el-table-column
                    prop="productDeclarationValue"
                    label="productDeclarationValue"
                    align="center"
                  ></el-table-column>
                  <!-- <el-table-column
                    label="Operation"
                    width="100"
                    fixed="right"
                    v-if="companyList.asnInf.status==7"
                  >
                 
                    <template slot-scope="scope" v-if="scope.row.isEdit!=0">
                      <a @click="edit(scope)">Edit</a>
                      
                    </template>
                  </el-table-column> -->
                </el-table>
                <el-col :span="24" class="right">SKU :{{companyList.asnItem.length}}</el-col>
                <el-col :span="24" class="right">Quantity :{{companyList.Quantity}}</el-col>
                <el-col :span="24" class="right">Weight :{{companyList.weight}}</el-col>
                <el-col :span="24" class="right">Declared price :{{companyList.price}}</el-col>
              </div>
            </el-card>
          </div>
        </el-tab-pane>

        <el-tab-pane label="Value-added services" name="second">
          <div style="height:10px"></div>
          <div v-if="companyList.specialService">
            <div v-if="companyList.specia">
              <el-card
                class="box-card"
                v-for="(itme,index) in companyList.specialService"
                :key="index"
              >
                <div slot="header" class="clearfix">
                  <span class="lebh">SKU information:{{itme[0].sku}}</span>
                  <span style="float: right; padding: 3px 0;">SPCode:{{itme.ss}}</span>
                </div>
                <div style="text-align: center">
                  <el-table :data="companyList.specialService[index]" stripe style="width: 100%">
                    <el-table-column prop="title" label="Value-added service name" align="center"></el-table-column>
                    <el-table-column prop="note" label="Service request" align="center"></el-table-column>
                  </el-table>
                </div>
              </el-card>
            </div>
            <div v-else>
              <el-card
                class="box-card"
                v-for="(itme,index) in companyList.specialService"
                :key="index"
              >
                <div slot="header" class="clearfix">
                  <span class="lebh">SKU information:{{itme[0].sku}}</span>
                  <span style="float: right; padding: 3px 0;">SPCode:{{itme.ss}}</span>
                </div>
                <div style="text-align: center">
                  <el-table :data="companyList.specialService[index]" stripe style="width: 100%">
                    <el-table-column prop="title" label="Value-added service name" align="center"></el-table-column>
                    <el-table-column prop="note" label="Service request" align="center"></el-table-column>
                  </el-table>
                </div>
              </el-card>
            </div>
          </div>
          <div v-else style="text-align: center;">
            <img src="../../../menu/img/nodata.png" alt="">
          <p>No value-added services</p>
            
            </div>
        </el-tab-pane>
        <el-tab-pane label="Log" name="third">
          <div class="block" style="width:80%;margin: 0 auto;">
            <el-timeline :reverse="reverse">
              <el-timeline-item
                v-for="(activity, index) in activities"
                :key="index"
                :timestamp="activity.rl_add_time"
              >{{activity.rl_note}}</el-timeline-item>
            </el-timeline>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div style="margin-top: 10px;">
        <el-button
          style="background:#8989ba;color:#fff;outline: none"
          @click="Printpacking"
        >Print packing list</el-button>
        <el-button
          style="background:#8989ba;color:#fff;outline: none"
          @click="Printproduct"
        >Print product label</el-button>
        <el-button
          style="background:#8989ba;color:#fff;outline: none"
          @click="information"
          v-if="companyList.asnInf.status==2||companyList.asnInf.status==0"
        >Modify information</el-button>
        <el-button
          type="danger"
          icon="el-icon-delete"
          circle
          style="float:right"
          v-if="companyList.asnInf.status==2"
          @click="remove"
        ></el-button>
      </div>
    </el-dialog>
    <div>
      <el-dialog
        title="Print product label"
        :close-on-click-modal="false"
        :visible.sync="dialogFormVisible"
        width="700px"
        center
        :before-close="clearPrint"
      >
        <el-table :data="companyList.asnItem" stripe style="width: 100%">
          <el-table-column prop="sku" label="sku" align="center"></el-table-column>
          <el-table-column prop="title" label="Product name" align="center"></el-table-column>
          <el-table-column prop="quantity" label="quantity" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.quantity"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <el-form
          :model="Printproductfrom"
          label-width="180px"
          ref="Printproductfrom"
          @submit.native.prevent
        >
          <el-form-item label="Barcode type :">
            <el-radio-group v-model="Printproductfrom.type">
              <el-radio :label="1">SFC barcode</el-radio>
              <el-radio :label="2">FBA barcode</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="Paper :">
            <el-radio-group v-model="Printproductfrom.Paper">
              <el-radio :label="1">A4</el-radio>
              <el-radio :label="2">Other</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="Size :">
            <el-radio-group v-model="Printproductfrom.Size">
              <el-radio :label="1">5cm*2cm</el-radio>
              <el-radio :label="2">Custom size</el-radio>
            </el-radio-group>
            <span v-if="Printproductfrom.Size==2">
              <el-input v-model="Printproductfrom.width" class="wid" placeholder="width"></el-input>X
              <el-input v-model="Printproductfrom.height" class="wid" placeholder="height"></el-input>cm
            </span>
          </el-form-item>
          <el-form-item label="Number of barcodes :">
            <el-input v-model="Printproductfrom.numbersInRow" class="wid"></el-input>Sheet / per line
          </el-form-item>
          <el-form-item label="Rows :">
            <el-input v-model="Printproductfrom.pageLine" class="wid"></el-input>Line/page
          </el-form-item>
          <el-form-item label="Spacing :">
            <el-input v-model="Printproductfrom.left" class="wid" placeholder="left"></el-input>
            <el-input v-model="Printproductfrom.right" class="wid" placeholder="right"></el-input>
            <el-input v-model="Printproductfrom.top" class="wid" placeholder="top"></el-input>
            <el-input v-model="Printproductfrom.bottom" class="wid" placeholder="bottom"></el-input>
          </el-form-item>
          <el-form-item>Tip: The width and height limit of the barcode cannot exceed 21cm*10cm</el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            style="background: rgb(137, 137, 186);color: rgb(255, 255, 255);outline: none;"
            @click="Confirmpen"
          >Confirm</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="Print box label"
        :close-on-click-modal="false"
        :visible.sync="PrintboxVisible"
        width="700px"
        center
      >
        <el-table
          :data="companyList.asnItem"
          stripe
          style="width: 100%"
          @selection-change="PrintboxChange"
        >
          <el-table-column type="selection" :reserve-selection="true" width="60" fixed="left"></el-table-column>
          <el-table-column prop="sku" label="sku" align="center"></el-table-column>
          <el-table-column prop="title" label="Product name" align="center"></el-table-column>
          <el-table-column prop="quantity" label="quantity" align="center"></el-table-column>
          <el-table-column prop="weight" label="weight" align="center"></el-table-column>
        </el-table>

        <div slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            style="background: rgb(137, 137, 186);color: rgb(255, 255, 255);outline: none;"
            @click="Confirmpenbox"
          >Confirm</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="Edit Expected Qty"
        :close-on-click-modal="false"
        :visible.sync="editVisible"
        width="700px"
        center
      >
        <el-form
          :model="ExpectedQty"
          label-width="180px"
          ref="Printproductfrom"
          @submit.native.prevent
        >
          <el-form-item label="SKU:">
            <span>{{ExpectedQty.sku}}</span>
          </el-form-item>
          <el-form-item label="Expected Qty :">
            <span>{{ExpectedQty.quantity}}</span>
          </el-form-item>
          <el-form-item label="revised quantity :">
            <el-input v-model="ExpectedQty.number" style="width:200px"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            style="background: rgb(137, 137, 186);color: rgb(255, 255, 255);outline: none;"
            @click="ConfirmQty"
          >Confirm</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { getasnlog, updateasnstatus,editreceivingitem } from "../../api/ans";
export default {
  props: ["companyList", "rolesList", "visible", "AsnCode"],

  data() {
    return {
      dialogFormVisible: false,
      ANSinput: "",
      addVisible: false,
      editVisible: false,
      PrintboxVisible: false,
      activeName: "",
      Unreceived: "Unreceived",
      SKU: "5",
      Quantity: "10",
      Weight: "10",
      Declaredprice: "10",
      ordernumber: "123545",
      ExpectedQty: {},
      Printproductfrom: {
        left: "",
        right: "",
        top: "",
        bottom: "",
        pageLine: 14,
        numbersInRow: 4,
        Size: 1,
        Paper: 1,
        width: "",
        height: "",
        type: 1
      },
      Printbox: [],
      tableData: [
        {
          Reservation: "1000",
          Actual: "10000",
          Qualified: "100000"
        }
      ],
      reverse: true,
      activities: []
    };
  },

  watch: {
    visible(val) {
      this.addVisible = val;
      this.activeName = "first";
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab);

      if (tab.label == "Log") {
        let params = {
          receiving_code: this.AsnCode
        };
        getasnlog(params)
          .then(response => {
            console.log(response);
            if (response.data.ask == 1) {
              if (response.data.data.constructor === Array) {
                this.activities = response.data.data;
              } else {
                let tableData = [];
                tableData.push(response.data.data);
                this.activities = tableData;
              }
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    clearAdd() {
      this.$emit("clearAdd");
      this.addVisible = false;
    },
    clearPrint() {
      this.dialogFormVisible = false;
    },
    PrintboxChange(val) {
      this.Printbox = val;
      console.log(val);
    },
    //搜索ANS单号
    ANSSearch() {
      console.log(this.ANSinput);
    },
    Printpacking() {
      this.PrintboxVisible = true;
    },
    Printproduct() {
      this.dialogFormVisible = true;
    },
    information() {
      console.log(this.AsnCode);
      this.$router.push({
        name: "editOrder",
        params: {
          asn_code: this.AsnCode
        }
      });
    },

    edit(val) {
      console.log(val);
      let param = {
        sku: val.row.sku,
        quantity: val.row.quantity,
        problemQuantity: val.row.problemQuantity,
        putawayQuantity: val.row.putawayQuantity,
        number: "",
        asnCode: this.AsnCode
      };
      this.ExpectedQty = param;
      this.editVisible = true;
      
    },
    ConfirmQty() {
      console.log(this.ExpectedQty);
      if (this.ExpectedQty.number != "") {
        if (
          this.ExpectedQty.putawayQuantity<Number(this.ExpectedQty.number)&& Number(this.ExpectedQty.number)<this.ExpectedQty.quantity
        ) {
       let param={
          receiving_code:this.ExpectedQty.asnCode,
          sku:this.ExpectedQty.sku,
          quantity:this.ExpectedQty.number,

       }
        editreceivingitem(param)
        .then(response => {
            console.log(response);
            if (response.data.ask == 1) {
               this.$message({
                message: response.data.msg,
                type: 'success'
              });
              this.editVisible = false;
                this.$emit("clearAdd");
                this.addVisible=false;
                 let param = {
                asn_status: 7
              };
              //this.list(param);
               this.$parent.list(param);
            }
          })
          .catch(error => {
            console.log(error);
          });

        } else {
          this.$message({
            type: "warning",
            message: "The quantity of new warehousing should not be less than the quantity of goods received."
          });
        }
      } else {
        this.$message({
          type: "warning",
          message: "Incorrect quantity"
        });
      }
    },
    remove() {
      this.$confirm("This action will delete the order and continue?", "Tips", {
        confirmButtonText: "Determine",
        cancelButtonText: "cancel",
        type: "warning"
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(255, 255, 255, 1)"
          });

          let param = {
            asn_code: this.AsnCode,
            asn_status: 0
          };
          updateasnstatus(param)
            .then(response => {
              loading.close();
              console.log(response);
              if (response.data.ask == 1) {
                this.clearAdd();
                let param = {
                  asn_status: 2
                };
                this.$parent.list(param);
                this.$parent.getcount();
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    Confirmpen() {
      //console.log(this.companyList.asnInf.warehouseId)
      let qty = "&";
      for (let i = 0; i < this.companyList.asnItem.length; i++) {
        qty +=
          "qty[" +
          this.companyList.asnItem[i].productId +
          "]" +
          "=" +
          this.companyList.asnItem[i].quantity +
          "&";
      }
      window.open(
        "http://fulfill.sendfromchina.com/merchant/product/print-label-new?labelType=" +
          this.Printproductfrom.type +
          "&paperType=" +
          this.Printproductfrom.Paper +
          "&type=" +
          this.Printproductfrom.Size +
          "&numbersInRow=" +
          this.Printproductfrom.numbersInRow +
          "&pageLine=" +
          this.Printproductfrom.pageLine +
          "&left=" +
          this.Printproductfrom.left +
          "&right=" +
          this.Printproductfrom.right +
          "&top=" +
          this.Printproductfrom.top +
          "&bottom=" +
          this.Printproductfrom.bottom +
          "&width=" +
          this.Printproductfrom.width +
          "&height=" +
          this.Printproductfrom.height +
          qty +
          "printWarehouse=" +
          this.companyList.asnInf.warehouseId
      );
    },
    Confirmpenbox() {
      console.log(this.Printbox.length);
      if (this.Printbox.length > 0) {
        let product_id = "";
        for (let i = 0; i < this.Printbox.length; i++) {
          product_id +=
            "product_id[" + i + "]" + "=" + this.Printbox[i].productId + "&";
          console.log(product_id);
        }
        window.open(
          "http://fulfill.sendfromchina.com/merchant/receiving/print-box-list-new?" +
            product_id +
            "receiving_id=" +
            this.companyList.asnInf.receivingId
        );
      } else {
        this.$message({
          type: "warning",
          message: "Please choose the product."
        });
      }
    }
  }
};
</script>
<style>
.purple div {
  height: 30px;
  line-height: 30px;
  font-size: 14px;
}
.right {
  text-align: right;
  font-size: 12px;
  color: #b0b0b0;
  padding: 5px;
}
.lebh {
  color: #8989ba;
  font-size: 16px;
  font-weight: blod;
}
.wid {
  width: 100px;
}
</style>






// WEBPACK FOOTER //
// src/components/views/AsnOrder/Ansdetails/Ansdetails.vue